import {I18nextProvider} from 'react-i18next';
import i18n from '@/locales/i18n';
import RoutesApp from '@/routers';
import {PublicClientApplication} from '@azure/msal-browser';
import {MsalProvider} from '@azure/msal-react';
import {msalConfig} from '@/configs/auth-config';
import '@/sass/App.css';
import {STORAGE_KEYS} from '@/constants';
import {useEffect} from 'react';
import Container from 'typedi';
import {EncryptionService} from '@/services/core/encryption.service';
import {EncryptionDTO} from '@/shared/dto/encryption.dto';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const encryptionService = Container.get(EncryptionService);

  useEffect(() => {
    const localStorage = window.localStorage;
    encryptionService.getPublicKey(new EncryptionDTO()).then((response) => {
      localStorage.setItem(STORAGE_KEYS.RSA_PUBLIC_KEY, response.data);
    });
  }, []);
  return (
    <MsalProvider instance={msalInstance}>
      <div className="App">
        <I18nextProvider i18n={i18n}>
          <RoutesApp />
        </I18nextProvider>
      </div>
    </MsalProvider>
  );
}

export default App;
